export interface IAccordionOptions {
    container?: HTMLElement;
    oneOpenAtATime: boolean;
}

export class Accordion {
    options: IAccordionOptions = {
        oneOpenAtATime: false
    }

    container: HTMLElement;
    panels: Array<HTMLElement>;
    triggers: Array<HTMLButtonElement>;
    activePanel: any;
    activeTrigger: any;

    constructor(options: IAccordionOptions) {
        Object.assign(this.options, options);
        this.container = this.options.container!;
        this.panels = Array.from(this.container.querySelectorAll('[role="region"]'));
        this.triggers = Array.from(this.container.querySelectorAll('[aria-controls]'));

        this.triggers.forEach(trigger => {
            trigger.addEventListener('click', this.accordionClick.bind(this));
        });

        const anchorLink = window.location.hash?.substring(1);
        if (!!anchorLink) {
            this.handleHash(anchorLink);
        }

        window.addEventListener('hashchange', (event: HashChangeEvent) => {
            this.handleHash(location.hash?.substring(1));
        });
    }

    handleHash(hash: string) {
        if (!hash) return;
        const activeTrigger = this.triggers.filter(trigger => trigger.parentElement?.id == hash);
        if (activeTrigger.length > 0) {
            const activePanel = this.container.querySelector(`#${activeTrigger[0].getAttribute('aria-controls')}`) as HTMLElement;
            const activeHeading = activeTrigger[0].parentElement;
            setTimeout(() => {
                this.openPanel(activeTrigger[0], activePanel);
                if (!!activeHeading) {
                    activeHeading.focus();
                    activeHeading.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }, 0);
        }
    }

    accordionClick(e: MouseEvent) {
        if (e.target) {
            this.activePanel = this.container.querySelector(`#${(e.target as HTMLButtonElement).getAttribute('aria-controls')}`);
            this.activeTrigger = e.target;
            this.toggleActivePanel();
            if (this.options.oneOpenAtATime) {
                this.closeInactivePanels();
            }
        }
    }

    toggleActivePanel() {
        if (this.activeTrigger.getAttribute('aria-expanded') === 'true') {
            const trigger = this.activeTrigger;
            this.activeTrigger = null;
            this.closePanel(trigger, this.activePanel);
        }
        else {
            this.openPanel(this.activeTrigger, this.activePanel);
        }
        if (this.options.oneOpenAtATime) {
            this.closeInactivePanels();
        }
    }

    closeInactivePanels() {
        this.triggers.forEach(trigger => {
            if (trigger !== this.activeTrigger) {
                let curPanel = this.container.querySelector(`#${trigger.getAttribute('aria-controls')}`)! as HTMLElement;
                this.closePanel(trigger, curPanel);
            }
        });
    }

    openPanel(trigger: HTMLButtonElement, panel: HTMLElement) {
        trigger.setAttribute('aria-expanded', 'true');
        panel.setAttribute('aria-hidden', 'false');
        panel.removeAttribute('inert');
    }

    closePanel(trigger: HTMLButtonElement, panel: HTMLElement) {
        trigger.setAttribute('aria-expanded', 'false');
        panel.setAttribute('aria-hidden', 'true');
        panel.setAttribute('inert', '');
    }
}